<template>
  <section
    data-auto-animate=""
    :data-background-video="videoUrl"
    :data-background-image="gifUrl"
    data-background-video-loop="true"
    data-background-opacity="0.4"
  >
    <div
      class="sl-block"
      data-block-type="text"
      data-name="text-a86498"
      data-block-id="f5b989af7f6f90391c1972112bed8388"
      style="height: auto; left: -220px; top: -75.5px"
    >
      <div
        class="sl-block-content"
        data-placeholder-tag="p"
        data-placeholder-text="Text"
        style="z-index: 10; text-align: left; color: rgb(255, 255, 255)"
      >
        <ul>
          <li
            v-for="item in exceptions"
            :key="'exception_' + item.id"
            style="padding-bottom: 20px; font-size: 0.9em; list-style: none"
          >
            <strong>{{ item.name }}</strong>
            {{ moment(item.firstOccurrred).fromNow() }} <br />

            {{ item.message }}<br />
             
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import Trimaster from "@/plugins/servers/trimaster.js";
import moment from "moment";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "",
  props: ["value"],
  components: {},
  beforeMount() {
    if (navigator.userAgent.indexOf("Silk") > 0) {
      this.gifUrl = "/img/presentationbackgrounds/warning.gif";
    } else {
      this.videoUrl = "/img/presentationbackgrounds/warning.mp4";
    }
    this.refresh();
  },
  mounted() {},
  data() {
    return {
      exceptions: [],
      moment: moment,
      gifUrl: null,
      videoUrl: null,
    };
  },

  computed: {
    ...mapGetters(["getUser"]),
  },
  watch: {},
  methods: {
    refresh() {
      let me = this;
      Trimaster.get("ExceptionLists", this.getUser.apitoken, {
        filter: {
          order: "lastOccurred DESC",
          limit: 3,
          where: {
            escalationLevel: 1,
            resolvedOn: null,
            facility_id: this.getUser.facility_id,
            code: { neq: "IRR-001" },
          },
        },
      }).then(function ([res, err]) {
        me.exceptions = res;
      });
    },
  },
};
</script>
<style>
#scorecardSlide td {
  font-size: 0.8em;
}
</style>

